import { render } from "./add.vue?vue&type=template&id=0a5dd613&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=0a5dd613&scoped=true&lang=css"
import "./add.vue?vue&type=style&index=1&id=0a5dd613&lang=css"

import exportComponent from "D:\\project\\item\\jts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5dd613"]])

export default __exports__